module.exports = __webpack_public_path__ + "media/mypage/images/icons/credit-cards/visa-ca9381964e10bbfdeeed8799f323cc69.png";